<template>
    <div class="vue-top">
        <div v-if="satisfyProgram && level" class="vue-top__title">
            <span v-html="satisfyText()"></span><br>
            {{ satisfyTextAdd(programs) }}
        </div>

        <div class="vue-top__actions">
            <button v-if="level && isLevelFlat"
                    type="button"
                    class="vue-top__action"
                    @click="$emit('getPdfLink')">
                <svg width="40"
                     height="40"
                     viewBox="0 0 40 40"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1"
                          width="40"
                          height="40"
                          rx="20"
                          fill="white" />
                    <path d="M20.2 13V21.4848M20.2 21.4848L23 18.5152M20.2 21.4848L17.4 18.5152M15 23.6061V27H25V23.6061"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round" />
                </svg>
            </button>

            <div class="vue-top__action-wrap" v-click-outside="clickOutside">
                <div :class="['vue-top__action', {'is-active': popoverOpen}]"
                     @click="popoverOpen = !popoverOpen">
                    <svg width="41"
                         height="40"
                         viewBox="0 0 41 40"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.1"
                              x="0.5"
                              width="40"
                              height="40"
                              rx="20"
                              fill="white"/>
                        <circle cx="24.7543"
                                cy="20.0043"
                                r="1.97301"
                                stroke="white"
                                stroke-width="1.25"/>
                        <circle cx="16.3109"
                                cy="15.4535"
                                r="1.97301"
                                stroke="white"
                                stroke-width="1.25"/>
                        <circle cx="16.3109"
                                cy="24.5433"
                                r="1.97301"
                                stroke="white"
                                stroke-width="1.25"/>
                        <path d="M22.8043 18.6985L18.2578 16.75M22.4796 20.9718C22.4796 21.2316 19.6651 22.5955 18.2578 23.245"
                              stroke="white"
                              stroke-width="1.25"/>
                    </svg>
                </div>

                <Share v-show="popoverOpen"
                       @popoverClose="popoverOpen = !popoverOpen"
                       :share="share"
                       @shareMail="shareMail"
                       :link="link"
                       ref="share"/>
            </div>
        </div>

        <Popup ref="popup"
               :isSuccess="isFormSuccess"
               :isError="isFormError"
               @popupClose="setFormInit">
            <ShareMail :personLink="personLink"
                       :isSuccess="isFormSuccess"
                       :isError="isFormError"
                       @formSuccess="setFormSendSuccess"
                       @formError="setFormSendError" />
        </Popup>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import Share from '../Share/Share';
import Popup from '../Popup/Popup';
import ShareMail from '../ShareMail/ShareMail';
import Utils from '../../helpers/Utils';

export default {
    components: {
        Share,
        Popup,
        ShareMail
    },

    directives: {
        clickOutside: vClickOutside.directive
    },

    props: ['personLink', 'share', 'satisfyProgram', 'level', 'programs'],

    data: () => ({
        popoverOpen: false,
        isFormSuccess: false,
        isFormError: false,
        link: window.location.href
    }),

    computed: {
        shareIsEmpty() {
            return Object.keys(this.share).length === 0 && this.share.constructor === Object;
        },

        isLevelFlat() {
            return this.level === 'flat';
        },

        isLevelObject() {
            return this.level === 'object';
        }
    },

    watch: {
        popoverOpen(val) {
            if (!val && this.$refs.share) {
                this.$refs.share.resetCopy();
            }
        }
    },

    methods: {
        clickOutside() {
            this.popoverOpen = false
        },

        shareMail() {
            this.$refs.popup.open();
            this.popoverOpen = false;
        },

        updateLink() {
            this.link = window.location.href;
        },

        setFormSendSuccess() {
            this.isFormSuccess = true;
            this.isFormError = false;
        },

        setFormSendError() {
            this.isFormSuccess = false;
            this.isFormError = true;
        },

        setFormInit() {
            this.isFormSuccess = false;
            this.isFormError = false;
        },

        satisfyText() {
            const sum = Number(this.satisfyProgram.programsCount);
            let result = '';

            if (sum > 0) {
                const mortgageWord = Utils.pluralWord(sum, ['ипотечная программа', 'ипотечные программы', 'ипотечных программ']);
                result = `Подходит ${sum} ${mortgageWord}`;

                if (!this.isLevelObject && !this.isLevelFlat) {
                    const houses = Number(this.satisfyProgram.houses);
                    const houseWord = Utils.pluralWord(houses, ['доме', 'домах', 'домах']);
                    result += ` на квартиры&nbsp;/&nbsp;апартаменты в ${houses} ${houseWord}.`;
                }
            } else {
                result = `По выбранным параметрам программ нет.`;
            }

            return result;
        },

        satisfyTextAdd(programs) {
            const disabledPrograms = programs.filter((item) => item.isDisabled);

            let result = '';

            if (programs.length && programs.length === disabledPrograms.length) {
                result += `Ниже вы видите все возможные программы без учета размера первого взноса. Для расчета ежемесячного платежа передвигайте ползунок с размером первого взноса.`
            }

            return result;
        }
    }
}
</script>

<style lang="scss">
@import "./Top";
</style>
